module.exports = __webpack_public_path__ + "static/photography_-a3085aca4ee6cb76f44e12cb96b699c5.png";